import { render, staticRenderFns } from "./goodsIndex.vue?vue&type=template&id=ea1317f8&scoped=true"
import script from "./goodsIndex.vue?vue&type=script&lang=js"
export * from "./goodsIndex.vue?vue&type=script&lang=js"
import style0 from "./goodsIndex.vue?vue&type=style&index=0&id=ea1317f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea1317f8",
  null
  
)

export default component.exports